import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useBranding } from "@/contexts/BrandingContext";
import PageMeta from "@/components/feature/PageMeta";

export default function ForgotPassword() {
  const branding = useBranding();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    setError("");
    try {
      await api.requestPasswordReset(email);
      setSuccess(true);
    } catch (err: any) {
      setError(err.message || "Error al solicitar recuperación");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex bg-[#080f1a] overflow-hidden">
      <PageMeta path="/forgot-password" />
      
      <div className="w-full lg:w-1/2 flex flex-col justify-center px-8 sm:px-16 lg:px-24 z-10">
        <Link to="/" className="absolute top-8 left-8 text-white/50 hover:text-white flex items-center gap-2 text-sm transition-colors">
          <i className="ri-arrow-left-line"></i> Volver al inicio
        </Link>
        <div className="max-w-md w-full mx-auto">
          <div className="mb-10 text-center">
            <img src={branding.logo_full} alt={branding.site_name} className="h-14 mx-auto mb-8" />
            <h1 className="text-3xl font-bold text-white mb-3">Recuperar Contraseña</h1>
            <p className="text-[var(--color-text-secondary)]">Ingresa tu correo y te enviaremos instrucciones.</p>
          </div>

          {error && (
            <div className="mb-6 bg-red-500/10 border border-red-500/20 text-red-400 p-4 rounded-xl text-sm flex items-center gap-3">
              <i className="ri-error-warning-line text-lg"></i>
              <p>{error}</p>
            </div>
          )}

          {success ? (
            <div className="text-center bg-green-500/10 border border-green-500/20 rounded-xl p-8 animate-[fadeIn_0.5s_ease-out]">
              <div className="w-16 h-16 bg-green-500/20 text-green-400 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-mail-send-line text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-2">Correo enviado</h3>
              <p className="text-[var(--color-text-secondary)] mb-6">Revisa tu bandeja de entrada o spam para continuar.</p>
              <Link to="/login" className="btn-secondary w-full flex items-center justify-center gap-2">
                Volver a Iniciar Sesión
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-semibold text-[var(--color-text-primary)] mb-2">Correo Electrónico</label>
                <div className="relative">
                  <i className="ri-mail-line absolute left-4 top-1/2 -translate-y-1/2 text-[var(--color-text-muted)]"></i>
                  <input
                    type="email"
                    required
                    className="input-field pl-11 py-3"
                    placeholder="nombre@empresa.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>

              <button type="submit" disabled={loading} className="btn-primary w-full flex items-center justify-center gap-2 cursor-pointer disabled:opacity-50 py-3">
                {loading ? <i className="ri-loader-4-line animate-spin"></i> : <><i className="ri-send-plane-line"></i> Enviar enlace</>}
              </button>

              <div className="text-center mt-6">
                <Link to="/login" className="text-sm text-[var(--color-text-secondary)] hover:text-white transition-colors">
                  Cancelar
                </Link>
              </div>
            </form>
          )}
        </div>
      </div>

      <div className="hidden lg:block w-1/2 relative bg-[var(--color-bg-card)]">
        <div className="absolute inset-0 bg-gradient-to-r from-[#080f1a] via-transparent to-transparent z-10"></div>
        <img src={branding.hero_login || "https://images.unsplash.com/photo-1542393046-277e9a0cfaee?auto=format&fit=crop&q=80"} alt="Capacitación" className="absolute inset-0 w-full h-full object-cover opacity-60 mix-blend-overlay" />
      </div>
    </div>
  );
}
